import "./styles.css";
import { Routes, Route, NavLink, useLocation } from "react-router-dom";
import {
  Brain,
  Cable,
  Database,
  FileJson,
  Globe,
  Network,
  ShieldAlert,
  UploadCloud,
  UsersRound,
} from "lucide-react";
import HandsPage from "@/modules/collector_v2/pages/HandsPage";
import HandDetailPage from "@/modules/collector_v2/pages/HandDetailPage";
import AlertsPage from "@/modules/collector_v2/pages/AlertsPage";
import PlayersPage from "@/modules/collector_v2/pages/PlayersPage";
import PlayerProfilePage from "@/modules/collector_v2/pages/PlayerProfilePage";
import RelationshipsPage from "@/modules/collector_v2/pages/RelationshipsPage";
import V2AlertsPage from "@/modules/collector_v2/pages/V2AlertsPage";
import V2CollectorPage from "@/modules/collector_v2/pages/V2CollectorPage";
import NetworkGraphPage from "@/modules/collector_v2/pages/NetworkGraphPage";
import BrainPage from "@/modules/collector_v2/pages/BrainPage";

const NAV_ITEMS = [
  { to: "collector", label: "Collector", icon: Cable, testid: "v2nav-collector" },
  { to: "arquitectura", label: "Arquitectura", icon: Database, testid: "v2nav-arch" },
  { to: "alertas", label: "Alertas V2", icon: ShieldAlert, testid: "v2nav-alerts" },
  { to: "manos", label: "Manos", icon: FileJson, testid: "v2nav-hands" },
  { to: "jugadores", label: "Jugadores", icon: UsersRound, testid: "v2nav-players" },
  { to: "relaciones", label: "Relaciones", icon: Network, testid: "v2nav-rel" },
  { to: "network", label: "Network", icon: Globe, testid: "v2nav-net" },
  { to: "brain", label: "Brain", icon: Brain, testid: "v2nav-brain" },
  { to: "importar", label: "Importar", icon: UploadCloud, testid: "v2nav-import" },
];

function ModuleNav() {
  return (
    <nav className="collector-v2-nav" data-testid="collector-v2-nav" style={{
      display: "flex", flexWrap: "wrap", gap: 8, padding: "12px 8px",
      borderBottom: "1px solid hsl(var(--border))", marginBottom: 16
    }}>
      {NAV_ITEMS.map((item) => {
        const Icon = item.icon;
        return (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            data-testid={item.testid}
            className={({ isActive }) => `v2-nav-item${isActive ? " v2-nav-item-active" : ""}`}
            style={({ isActive }) => ({
              display: "inline-flex", alignItems: "center", gap: 6,
              padding: "8px 14px", borderRadius: 10, fontSize: 14, fontWeight: 500,
              textDecoration: "none",
              background: isActive ? "hsl(var(--primary))" : "hsl(var(--muted))",
              color: isActive ? "hsl(var(--primary-foreground))" : "hsl(var(--foreground))",
              transition: "background-color 150ms ease, color 150ms ease",
            })}
          >
            <Icon className="h-4 w-4" />
            {item.label}
          </NavLink>
        );
      })}
    </nav>
  );
}

export default function CollectorV2Module() {
  return (
    <div className="collector-v2-module" data-testid="collector-v2-module">
      <div className="collector-v2-content">
        <Routes>
          <Route index element={<V2CollectorPage />} />
          <Route path="collector" element={<V2CollectorPage />} />
          <Route path="alertas" element={<V2AlertsPage />} />
          <Route path="alertas-legacy" element={<AlertsPage />} />
          <Route path="manos" element={<HandsPage />} />
          <Route path="manos/:handId" element={<HandDetailPage />} />
          <Route path="jugadores" element={<PlayersPage />} />
          <Route path="jugadores/:uid" element={<PlayerProfilePage />} />
          <Route path="relaciones" element={<RelationshipsPage />} />
          <Route path="network" element={<NetworkGraphPage />} />
          <Route path="brain" element={<BrainPage />} />
        </Routes>
      </div>
    </div>
  );
}
